<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="450px"
    @close="$router.replace('/data/categories')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="productCategory"
      :rules="rules"
      ref="productCategoryForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="name"
        label="Név"
      >
        <el-input
          v-model="productCategory.name"
        />
      </el-form-item>
      <el-form-item
        prop="availableParents"
        label="Szülő kategória"
      >
        <el-cascader
          v-model="productCategory.parent_id"
          :options="productCategory.availableParents"
          :props="{ checkStrictly: true, label: 'name', value: 'id', emitPath: false }"
          style="width: 100%"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/data/categories')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['type', 'productCategoryId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        productCategory: {},
        rules: {
          name: [
            { required: true, message: 'Mező megadása kötelező', trigger: 'change' }
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Kategória';
        } else if (this.type === 'update') {
          return 'Kategória módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    methods: {
      async add() {
        this.$refs['productCategoryForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('productCategory/create', this.productCategory);
              } else if (this.type === 'update') {
                await this.$store.dispatch('productCategory/update', this.productCategory);
              }
              this.$store.dispatch('productCategory/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/data/categories');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      }
    },
    async mounted() {
      this.loading = true;
      if (this.productCategoryId) {
        this.productCategory = await this.$store.dispatch('productCategory/fetch', this.productCategoryId);
      } else {
        this.productCategory.availableParents = this.$store.getters['productCategory/productCategories'];
      }
      this.loading = false;
    },
  };
</script>
